import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入自定义样式
import "./scss/elementui.scss";

// 绑定 api
import api from "./util/api";
Vue.prototype.$api = api;

import VueI18n from 'vue-i18n'
import { resolveLang } from "./util/lang";
Vue.use(VueI18n)

// 优先用户端语言：日语环境显示日语，其余默认中文
const lang = resolveLang();
const i18n = new VueI18n({
  locale: lang || 'ch',
  messages: {
    'ch': require("./plugin/zh_Ch"),  // 中文语言包
    'jp': require("./plugin/ja_JP"),  // 日文语言包
  }
})

// 全局引入组件
import plugin from "./plugin";
Vue.use(plugin);

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
